
/*
 * @Author: your name
 * @Date: 2022-02-10 16:26:40
 * @LastEditTime: 2022-03-02 11:33:01
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\config\modules.synergy.router.config.js
 */

export const workbenchRouterMap = [
  {
    path: '/',
    name: 'aa',
    component: () => import('@/components/page/GlobalLayout'),
    redirect: '/project',
    children: [{
      path: '/project',
      name: 'Workbench',
      component: () => import('@/views/modules/workbench/project'),
      meta: { title: '项目' },
      children: [
        {
          path: '/project',
          name: 'project',
          component: () => import('@/views/modules/workbench/project/main')
        },
        {
          path: '/solution/:projectId',
          name: 'solution',
          component: () => import('@/views/modules/workbench/solution')
        }
      ]
    }]
  }
]
